import { render, staticRenderFns } from "./HeaderProductDetail.vue?vue&type=template&id=cd7ff19a&"
import script from "./HeaderProductDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports